<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9234_68180)">
      <path d="M16.7009 28.0078C22.7748 28.0078 27.6987 23.0839 27.6987 17.01C27.6987 10.9361 22.7748 6.01221 16.7009 6.01221C10.627 6.01221 5.70312 10.9361 5.70312 17.01C5.70312 23.0839 10.627 28.0078 16.7009 28.0078Z"
            fill="url(#paint0_linear_9234_68180)"
      />
      <path d="M16.7009 28.0078C22.7748 28.0078 27.6987 23.0839 27.6987 17.01C27.6987 10.9361 22.7748 6.01221 16.7009 6.01221C10.627 6.01221 5.70312 10.9361 5.70312 17.01C5.70312 23.0839 10.627 28.0078 16.7009 28.0078Z"
            fill="url(#paint1_radial_9234_68180)"
      />
      <path d="M16.7009 28.0078C22.7748 28.0078 27.6987 23.0839 27.6987 17.01C27.6987 10.9361 22.7748 6.01221 16.7009 6.01221C10.627 6.01221 5.70312 10.9361 5.70312 17.01C5.70312 23.0839 10.627 28.0078 16.7009 28.0078Z"
            fill="url(#paint2_radial_9234_68180)"
      />
      <path d="M16.7009 28.0078C22.7748 28.0078 27.6987 23.0839 27.6987 17.01C27.6987 10.9361 22.7748 6.01221 16.7009 6.01221C10.627 6.01221 5.70312 10.9361 5.70312 17.01C5.70312 23.0839 10.627 28.0078 16.7009 28.0078Z"
            fill="url(#paint3_radial_9234_68180)"
      />
      <path d="M16.7009 28.0078C22.7748 28.0078 27.6987 23.0839 27.6987 17.01C27.6987 10.9361 22.7748 6.01221 16.7009 6.01221C10.627 6.01221 5.70312 10.9361 5.70312 17.01C5.70312 23.0839 10.627 28.0078 16.7009 28.0078Z"
            fill="url(#paint4_radial_9234_68180)"
      />
      <path d="M16.7009 28.0078C22.7748 28.0078 27.6987 23.0839 27.6987 17.01C27.6987 10.9361 22.7748 6.01221 16.7009 6.01221C10.627 6.01221 5.70312 10.9361 5.70312 17.01C5.70312 23.0839 10.627 28.0078 16.7009 28.0078Z"
            fill="url(#paint5_radial_9234_68180)"
      />
      <path d="M16.7008 24.5769C20.88 24.5769 24.2678 21.189 24.2678 17.0099C24.2678 12.8307 20.88 9.44287 16.7008 9.44287C12.5217 9.44287 9.13379 12.8307 9.13379 17.0099C9.13379 21.189 12.5217 24.5769 16.7008 24.5769Z"
            fill="#D8CBF0"
      />
      <path d="M16.7008 24.5769C20.88 24.5769 24.2678 21.189 24.2678 17.0099C24.2678 12.8307 20.88 9.44287 16.7008 9.44287C12.5217 9.44287 9.13379 12.8307 9.13379 17.0099C9.13379 21.189 12.5217 24.5769 16.7008 24.5769Z"
            fill="url(#paint6_radial_9234_68180)"
      />
      <path d="M16.7008 24.5769C20.88 24.5769 24.2678 21.189 24.2678 17.0099C24.2678 12.8307 20.88 9.44287 16.7008 9.44287C12.5217 9.44287 9.13379 12.8307 9.13379 17.0099C9.13379 21.189 12.5217 24.5769 16.7008 24.5769Z"
            fill="url(#paint7_radial_9234_68180)"
      />
      <path d="M16.7008 24.5769C20.88 24.5769 24.2678 21.189 24.2678 17.0099C24.2678 12.8307 20.88 9.44287 16.7008 9.44287C12.5217 9.44287 9.13379 12.8307 9.13379 17.0099C9.13379 21.189 12.5217 24.5769 16.7008 24.5769Z"
            fill="url(#paint8_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint9_linear_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint10_linear_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="black"
            fill-opacity="0.05"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint11_linear_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint12_linear_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint13_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint14_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint15_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint16_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint17_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint18_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint19_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint20_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint21_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint22_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint23_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint24_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint25_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint26_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint27_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint28_radial_9234_68180)"
      />
      <path d="M7.99738 5.04224C7.52694 5.04224 7.15555 5.37169 7.15555 5.7649V9.08257C7.15555 9.29512 6.95747 9.45451 6.72225 9.45451C6.47465 9.45451 6.28896 9.28449 6.28896 9.08257V5.79679C6.28896 5.40357 5.92994 5.05287 5.47189 5.04224C4.98907 5.03161 4.5929 5.36106 4.5929 5.7649V9.08257C4.5929 9.29512 4.39484 9.45451 4.15962 9.45451C3.91202 9.45451 3.72631 9.28449 3.72631 9.08257V5.79679C3.72631 5.40357 3.36729 5.05287 2.90924 5.04224C2.42642 5.03161 2.03027 5.36106 2.03027 5.7649V8.99564V9.55893V11.5959C2.03027 13.6517 4.14723 14.2088 4.14723 15.6624C4.14723 17.116 4.14723 28.672 4.14723 28.672C4.14723 29.3784 4.74212 30.0006 5.45331 30.0006C6.1645 30.0006 6.75939 29.3784 6.75939 28.672C6.75939 28.672 6.75939 17.1677 6.75939 15.6624C6.75939 14.1571 8.87636 13.6674 8.87636 11.5959V9.55893V8.99564V5.7649C8.8516 5.37169 8.46781 5.04224 7.99738 5.04224Z"
            fill="url(#paint29_radial_9234_68180)"
      />
      <path d="M29.8269 7.03997C29.8269 5.93677 28.9128 5.04199 27.7858 5.04199C26.158 5.04199 24.8557 6.32905 24.8683 7.91029V14.7133C24.8683 16.2604 25.7593 17.6443 27.1846 18.2609V28.8083C27.1846 29.4631 27.7105 29.9921 28.3617 29.9921H28.6497C29.3008 29.9921 29.8267 29.4631 29.8267 28.8083L29.8269 7.03997Z"
            fill="url(#paint30_linear_9234_68180)"
      />
      <path d="M29.8269 7.03997C29.8269 5.93677 28.9128 5.04199 27.7858 5.04199C26.158 5.04199 24.8557 6.32905 24.8683 7.91029V14.7133C24.8683 16.2604 25.7593 17.6443 27.1846 18.2609V28.8083C27.1846 29.4631 27.7105 29.9921 28.3617 29.9921H28.6497C29.3008 29.9921 29.8267 29.4631 29.8267 28.8083L29.8269 7.03997Z"
            fill="url(#paint31_radial_9234_68180)"
      />
      <path d="M29.8269 7.03997C29.8269 5.93677 28.9128 5.04199 27.7858 5.04199C26.158 5.04199 24.8557 6.32905 24.8683 7.91029V14.7133C24.8683 16.2604 25.7593 17.6443 27.1846 18.2609V28.8083C27.1846 29.4631 27.7105 29.9921 28.3617 29.9921H28.6497C29.3008 29.9921 29.8267 29.4631 29.8267 28.8083L29.8269 7.03997Z"
            fill="url(#paint32_radial_9234_68180)"
      />
      <path d="M29.8269 7.03997C29.8269 5.93677 28.9128 5.04199 27.7858 5.04199C26.158 5.04199 24.8557 6.32905 24.8683 7.91029V14.7133C24.8683 16.2604 25.7593 17.6443 27.1846 18.2609V28.8083C27.1846 29.4631 27.7105 29.9921 28.3617 29.9921H28.6497C29.3008 29.9921 29.8267 29.4631 29.8267 28.8083L29.8269 7.03997Z"
            fill="url(#paint33_radial_9234_68180)"
      />
      <path d="M29.8269 7.03997C29.8269 5.93677 28.9128 5.04199 27.7858 5.04199C26.158 5.04199 24.8557 6.32905 24.8683 7.91029V14.7133C24.8683 16.2604 25.7593 17.6443 27.1846 18.2609V28.8083C27.1846 29.4631 27.7105 29.9921 28.3617 29.9921H28.6497C29.3008 29.9921 29.8267 29.4631 29.8267 28.8083L29.8269 7.03997Z"
            fill="url(#paint34_radial_9234_68180)"
      />
      <path d="M29.8269 7.03997C29.8269 5.93677 28.9128 5.04199 27.7858 5.04199C26.158 5.04199 24.8557 6.32905 24.8683 7.91029V14.7133C24.8683 16.2604 25.7593 17.6443 27.1846 18.2609V28.8083C27.1846 29.4631 27.7105 29.9921 28.3617 29.9921H28.6497C29.3008 29.9921 29.8267 29.4631 29.8267 28.8083L29.8269 7.03997Z"
            fill="url(#paint35_radial_9234_68180)"
      />
      <path d="M29.8269 7.03997C29.8269 5.93677 28.9128 5.04199 27.7858 5.04199C26.158 5.04199 24.8557 6.32905 24.8683 7.91029V14.7133C24.8683 16.2604 25.7593 17.6443 27.1846 18.2609V28.8083C27.1846 29.4631 27.7105 29.9921 28.3617 29.9921H28.6497C29.3008 29.9921 29.8267 29.4631 29.8267 28.8083L29.8269 7.03997Z"
            fill="url(#paint36_radial_9234_68180)"
      />
      <path d="M29.8269 7.03997C29.8269 5.93677 28.9128 5.04199 27.7858 5.04199C26.158 5.04199 24.8557 6.32905 24.8683 7.91029V14.7133C24.8683 16.2604 25.7593 17.6443 27.1846 18.2609V28.8083C27.1846 29.4631 27.7105 29.9921 28.3617 29.9921H28.6497C29.3008 29.9921 29.8267 29.4631 29.8267 28.8083L29.8269 7.03997Z"
            fill="url(#paint37_radial_9234_68180)"
      />
      <path d="M29.8269 7.03997C29.8269 5.93677 28.9128 5.04199 27.7858 5.04199C26.158 5.04199 24.8557 6.32905 24.8683 7.91029V14.7133C24.8683 16.2604 25.7593 17.6443 27.1846 18.2609V28.8083C27.1846 29.4631 27.7105 29.9921 28.3617 29.9921H28.6497C29.3008 29.9921 29.8267 29.4631 29.8267 28.8083L29.8269 7.03997Z"
            fill="url(#paint38_radial_9234_68180)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_9234_68180"
                      x1="15.447"
                      y1="6.01221"
                      x2="16.7009"
                      y2="28.0078"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.115334"
              stop-color="#BCBBC4"
        />
        <stop offset="0.227922"
              stop-color="#8F8D9B"
        />
        <stop offset="0.689257"
              stop-color="#A8A0BC"
        />
        <stop offset="0.766146"
              stop-color="#BFA1E2"
        />
      </linearGradient>
      <radialGradient id="paint1_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.7009 17.01) rotate(90) scale(10.9978 10.9978)"
      >
        <stop offset="0.943572"
              stop-color="#DDCEF5"
        />
        <stop offset="1"
              stop-color="#DDCEF5"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(12.5186 18) rotate(-36.6264) scale(10.3789 10.3789)"
      >
        <stop offset="0.324467"
              stop-color="#EAE0FD"
        />
        <stop offset="0.633232"
              stop-color="#E7DDF9"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint3_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.4163 19.6326) rotate(144.796) scale(13.1791 16.4821)"
      >
        <stop offset="0.856316"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.890511"
              stop-color="#FFFFFF"
              stop-opacity="0.3"
        />
        <stop offset="0.956564"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint4_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(26.4687 13.8437) rotate(88.5024) scale(4.78288 2.42376)"
      >
        <stop offset="0.675676"
              stop-color="#C2B2DB"
        />
        <stop offset="1"
              stop-color="#C2B2DB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint5_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.375 13.2187) rotate(82.7368) scale(6.42657 3.25671)"
      >
        <stop offset="0.675676"
              stop-color="#C2B2DB"
        />
        <stop offset="1"
              stop-color="#C2B2DB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint6_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.447 18.4546) rotate(82.9973) scale(10.2845 11.7776)"
      >
        <stop offset="0.596424"
              stop-color="#DACEF3"
        />
        <stop offset="0.754428"
              stop-color="#CCB9EB"
        />
        <stop offset="0.962131"
              stop-color="#BCA7DC"
        />
      </radialGradient>
      <radialGradient id="paint7_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.5207 11.6897) rotate(142.239) scale(18.642 17.7929)"
      >
        <stop offset="0.476664"
              stop-color="#DACEF3"
              stop-opacity="0"
        />
        <stop offset="0.693657"
              stop-color="#E9E2FD"
        />
        <stop offset="0.816307"
              stop-color="#EBE8FB"
        />
        <stop offset="0.962131"
              stop-color="#EAE7F9"
        />
      </radialGradient>
      <radialGradient id="paint8_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(12.3061 12.4749) rotate(56.149) scale(17.8914 20.489)"
      >
        <stop offset="0.536739"
              stop-color="#DACEF3"
              stop-opacity="0"
        />
        <stop offset="0.754428"
              stop-color="#B9B5CA"
        />
        <stop offset="0.962131"
              stop-color="#B2AEC4"
        />
      </radialGradient>
      <linearGradient id="paint9_linear_9234_68180"
                      x1="4.11845"
                      y1="22.7053"
                      x2="6.76348"
                      y2="22.7053"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A29CAE" />
        <stop offset="0.2"
              stop-color="#AFA5C1"
        />
        <stop offset="0.789474"
              stop-color="#C9C1D9"
        />
        <stop offset="1"
              stop-color="#BFBACB"
        />
      </linearGradient>
      <linearGradient id="paint10_linear_9234_68180"
                      x1="5.45332"
                      y1="5.04199"
                      x2="5.45332"
                      y2="30.0006"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.389773"
              stop-color="#BBB2CC"
        />
        <stop offset="0.432164"
              stop-color="#BEB5CE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_9234_68180"
                      x1="5.45332"
                      y1="5.04199"
                      x2="5.45332"
                      y2="30.0006"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.001543"
              stop-color="#9F9BA9"
        />
        <stop offset="0.0266132"
              stop-color="#9F9BA9"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_9234_68180"
                      x1="2.03027"
                      y1="22.7053"
                      x2="8.87645"
                      y2="22.7053"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A29CAE" />
        <stop offset="0.0631842"
              stop-color="#A29CAE"
              stop-opacity="0"
        />
        <stop offset="0.934443"
              stop-color="#A29CAE"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#A29CAE"
        />
      </linearGradient>
      <radialGradient id="paint13_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3.92355 9.11818) rotate(90) scale(0.793508)"
      >
        <stop stop-color="#FFFFFF" />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint14_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(4.13237 6.59845) rotate(90) scale(3.68911 0.907443)"
      >
        <stop offset="0.37766"
              stop-color="#A29CAE"
        />
        <stop offset="1"
              stop-color="#A29CAE"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint15_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(4.13237 8.99289) rotate(90) scale(0.835271)"
      >
        <stop stop-color="#A29CAE" />
        <stop offset="1"
              stop-color="#A29CAE"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint16_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(6.73563 6.72374) rotate(90) scale(3.56382 0.876624)"
      >
        <stop offset="0.37766"
              stop-color="#A29CAE"
        />
        <stop offset="1"
              stop-color="#A29CAE"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint17_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(6.50671 9.14912) rotate(90) scale(0.711527)"
      >
        <stop stop-color="#FFFFFF" />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint18_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(6.73563 8.97897) rotate(90) scale(0.849192)"
      >
        <stop offset="0.477231"
              stop-color="#A29CAE"
        />
        <stop offset="1"
              stop-color="#A29CAE"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint19_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3.31196 5.50003) rotate(41.4237) scale(0.708728 0.865703)"
      >
        <stop stop-color="#C9C7D0" />
        <stop offset="1"
              stop-color="#CDCAD5"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint20_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(5.81281 5.3281) rotate(39.2072) scale(0.766524 0.9363)"
      >
        <stop stop-color="#C9C7D0" />
        <stop offset="1"
              stop-color="#CDCAD5"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint21_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.42308 5.31247) rotate(48.6914) scale(0.686668 0.838757)"
      >
        <stop stop-color="#C9C7D0" />
        <stop offset="1"
              stop-color="#CDCAD5"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint22_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(5.45337 0.821157) rotate(90) scale(29.1795 7.2375)"
      >
        <stop offset="0.961641"
              stop-color="#9883B3"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#8F78AB"
        />
      </radialGradient>
      <radialGradient id="paint23_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(2.66446 13.7524) rotate(46.106) scale(2.49334 0.683918)"
      >
        <stop stop-color="#A19CAB" />
        <stop offset="1"
              stop-color="#A19CAB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint24_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(1.67959 13.0529) rotate(60.6758) scale(2.79877 1.19125)"
      >
        <stop stop-color="#A19CAB" />
        <stop offset="1"
              stop-color="#A19CAB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint25_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.60107 13.1275) rotate(103.241) scale(1.45874 0.620888)"
      >
        <stop stop-color="#A19CAB" />
        <stop offset="1"
              stop-color="#A19CAB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint26_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.12775 13.8096) rotate(133.091) scale(2.36382 0.648389)"
      >
        <stop stop-color="#A19CAB" />
        <stop offset="1"
              stop-color="#A19CAB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint27_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.44794 8.53349) rotate(90) scale(3.64735 0.375871)"
      >
        <stop offset="0.37766"
              stop-color="#FFFFFF"
              stop-opacity="0.15"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint28_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(5.96842 7.28677) rotate(90) scale(2.14077 0.273219)"
      >
        <stop offset="0.37766"
              stop-color="#FFFFFF"
              stop-opacity="0.17"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint29_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3.36671 7.53116) rotate(90) scale(1.97681 0.252293)"
      >
        <stop offset="0.37766"
              stop-color="#FFFFFF"
              stop-opacity="0.18"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint30_linear_9234_68180"
                      x1="29.8269"
                      y1="12.0624"
                      x2="27.0606"
                      y2="12.0624"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C4C2CB" />
        <stop offset="0.514744"
              stop-color="#B2A8C2"
        />
        <stop offset="1"
              stop-color="#948CA2"
        />
      </linearGradient>
      <radialGradient id="paint31_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(24.8682 17.5223) rotate(35.4843) scale(4.50209 1.50615)"
      >
        <stop stop-color="#9B89B3" />
        <stop offset="1"
              stop-color="#A28EBB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint32_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(26.8879 11.3269) rotate(0.616057) scale(2.30238 9.0123)"
      >
        <stop offset="0.682353"
              stop-color="#B1A8C0"
        />
        <stop offset="1"
              stop-color="#BBB4C8"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint33_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(29.0749 17.0926) rotate(-157.62) scale(0.359394 1.32607)"
      >
        <stop stop-color="#D7D2E0"
              stop-opacity="0.8"
        />
        <stop offset="1"
              stop-color="#E1DEE8"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint34_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.8727 17.6888) rotate(-71.9657) scale(0.442006 1.06341)"
      >
        <stop stop-color="#D7D2E0"
              stop-opacity="0.5"
        />
        <stop offset="1"
              stop-color="#E1DEE8"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint35_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.8208 17.0144) rotate(-152.354) scale(0.463425 1.70992)"
      >
        <stop stop-color="#BAB2C7" />
        <stop offset="1"
              stop-color="#BAB2C7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint36_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.5586 17.2207) rotate(-65.4623) scale(0.464015 1.7121)"
      >
        <stop stop-color="#BAB2C7" />
        <stop offset="1"
              stop-color="#BAB2C7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint37_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(29.1494 6.40613) rotate(136.219) scale(1.0388 1.62421)"
      >
        <stop stop-color="#D7D2E0" />
        <stop offset="1"
              stop-color="#E1DEE8"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint38_radial_9234_68180"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.497 6.54908) rotate(135) scale(1.19032 1.86112)"
      >
        <stop stop-color="#BAB3C8" />
        <stop offset="1"
              stop-color="#BAB3C8"
              stop-opacity="0"
        />
      </radialGradient>
      <clipPath id="clip0_9234_68180">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>